import { render, staticRenderFns } from "./SocialPostMessageCounter.vue?vue&type=template&id=8c6fd394&scoped=true&"
import script from "./SocialPostMessageCounter.vue?vue&type=script&lang=js&"
export * from "./SocialPostMessageCounter.vue?vue&type=script&lang=js&"
import style0 from "./SocialPostMessageCounter.vue?vue&type=style&index=0&id=8c6fd394&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6fd394",
  null
  
)

export default component.exports